/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { PrimaryButton, Button } from 'ui';
import s from './styles.module.scss';

interface WeChatAccountChoiceProps {
  registrationToken: string;
}

const WeChatAccountChoice: React.FC<WeChatAccountChoiceProps> = ({ registrationToken }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleExistingAccount = () => {
    // Store the registration token for the login link flow
    localStorage.setItem('wechat_registration_token', registrationToken);
    // Redirect to login link page
    navigate('/wechat/login-link', { replace: true });
  };

  const handleNewAccount = () => {
    // Registration data is already stored after the OAuth callback.
    navigate('/registration?wechat=true', { replace: true });
  };

  const handleBackToLogin = () => {
    navigate('/', { replace: true });
  };

  return (
    <div className={s.sharedForm}>
      <div className={s.wechatCallbackContainer}>
        <h2 className={s.wechatCallbackTitle}>{t('wechat_account_choice_title')}</h2>
        <p className={s.wechatCallbackProcessingText}>{t('wechat_account_choice_description')}</p>

        <div className={s.wechatAccountChoiceButtons}>
          <PrimaryButton type="button" className={s.sharedFormSubmit} onClick={handleExistingAccount}>
            {t('wechat_account_choice_existing')}
          </PrimaryButton>

          <Button type="button" className={s.sharedFormSubmit} onClick={handleNewAccount}>
            {t('wechat_account_choice_new')}
          </Button>
        </div>

        <div className={s.wechatAccountChoiceBack}>
          <a
            href="#"
            className={s.sharedFormFooterLink}
            onClick={(e) => {
              e.preventDefault();
              handleBackToLogin();
            }}
          >
            {t('back_to_login')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default WeChatAccountChoice;
